export default __webpack_public_path__ + "static/media/overview-default.e5bdc71c.svg";